/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdsprachen10Inputs */

const en__field_enum_sdsprachen10 = /** @type {(inputs: _Field_Enum_Sdsprachen10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09 - Sprach- und Kulturwissenschaften`)
};

const de__field_enum_sdsprachen10 = /** @type {(inputs: _Field_Enum_Sdsprachen10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09 - Sprach- und Kulturwissenschaften`)
};

/**
* | output |
* | --- |
* | "09 - Sprach- und Kulturwissenschaften" |
*
* @param {_Field_Enum_Sdsprachen10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdsprachen10 = /** @type {((inputs?: _Field_Enum_Sdsprachen10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdsprachen10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdsprachen10(inputs)
	return de__field_enum_sdsprachen10(inputs)
});
export { _field_enum_sdsprachen10 as "_field_enum_SDSPRACHEN" }